import React, { useState } from "react";
import Sidebar from "./components/Sidebar";
import { Routes, Route } from "react-router-dom";

import Workers from "./pages/workers/WorkersMaster";
import Items from "./pages/items/ItemsMaster";
import Diamonds from "./pages/diamonds/DiamondsMaster";
import MasterFiling from "./pages/master/MasterFiling";
import Ledger from "./pages/ledger/Ledger";
import MasterClear from "./pages/master/MasterClear";
import DiamondTransactions from "./pages/master/DiamondTransactions";
import DiamondLedger from "./pages/diamonds/DiamondLedger";
import IssueWax from "./pages/wax/IssueWax";
import ReceiveWax from "./pages/wax/ReceiveWax";
import CompletedWax from "./pages/wax/CompletedWax";
import CastingDoneWax from "./pages/wax/CastingDoneWax";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      {/* MOBILE HAMBURGER */}
      <button className="hamburger-btn" onClick={() => setSidebarOpen(true)}>
        ☰
      </button>

      <div style={{ display: "flex" }}>
        <Sidebar isOpen={sidebarOpen} closeSidebar={() => setSidebarOpen(false)} />

        <div className="page-container">
          <Routes>
            <Route path="/" element={<Workers />} />
            <Route path="/workers" element={<Workers />} />
            <Route path="/items" element={<Items />} />
            <Route path="/diamonds" element={<Diamonds />} />
            <Route path="/master-filing" element={<MasterFiling />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/master-clear" element={<MasterClear />} />
            <Route path="/diamond-transactions" element={<DiamondTransactions />} />
            <Route path="/diamond-ledger" element={<DiamondLedger />} />
            <Route path="/wax-issue" element={<IssueWax />} />
            <Route path="/wax-receive" element={<ReceiveWax />} />
            <Route path="/wax-completed" element={<CompletedWax />} />
            <Route path="/wax-casting" element={<CastingDoneWax />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default App;
